// extracted by mini-css-extract-plugin
export var csatScore = "_mt-5";
export var header = "_mt-1";
export var panelWrapper = "_mt-2";
export var postPreview = "_mt-3";
export var rightContent = "_mt-0";
export var wrappingText = "_mt-4";